import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedDateTime from 'I18n/components/FormattedDateTime';
import { areDifferentDates } from '../utils/areDifferentDates';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const DateDivider = ({
  timestamp
}) => {
  var _I18n$moment$toISOStr;
  const today = new Date().getTime();
  const isFromToday = !areDifferentDates(timestamp, today);
  return /*#__PURE__*/_jsxs(Flex, {
    justifyContent: "center",
    alignItems: "center",
    paddingBlock: "400",
    position: "relative",
    children: [/*#__PURE__*/_jsx(Flex, {
      backgroundColor: "fill-accent-neutral-subtle",
      blockSize: "2px",
      inlineSize: "100%"
    }), /*#__PURE__*/_jsx(Flex, {
      position: "absolute",
      backgroundColor: "fill-accent-neutral-subtle",
      paddingBlock: "100",
      paddingInline: "300",
      borderRadius: "full",
      children: /*#__PURE__*/_jsx(Text, {
        typography: "detail-200",
        color: "text-core-default",
        children: isFromToday ? /*#__PURE__*/_jsx(FormattedMessage, {
          message: "customer-portal-app.ticketThread.timestamp.today"
        }) : /*#__PURE__*/_jsx("time", {
          dateTime: (_I18n$moment$toISOStr = I18n.moment(timestamp).toISOString()) !== null && _I18n$moment$toISOStr !== void 0 ? _I18n$moment$toISOStr : undefined,
          children: /*#__PURE__*/_jsx(FormattedDateTime, {
            value: timestamp,
            format: "medium-date",
            type: "userTz"
          })
        })
      })
    })]
  });
};